var React = require('react');

function IcBookmarkFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.68008 2.66729V2.66667C1.68008 1.74575 2.42555 1 3.33341 1H16.6667C17.5811 1 18.3334 1.75229 18.3334 2.66667V22.4835L10.394 19.0809L10.0001 18.912L9.60616 19.0809L1.6677 22.4831L1.68008 2.66729Z","fill":"black","stroke":"black","strokeWidth":"2"}));
}

IcBookmarkFilled.defaultProps = {"width":"20","height":"24","viewBox":"0 0 20 24","fill":"none"};

module.exports = IcBookmarkFilled;

IcBookmarkFilled.default = IcBookmarkFilled;
